import $ from 'jquery';
import { createApp } from 'vue/dist/vue.esm-bundler.js';

import FlightInfoSmall from 'Vue/components/flightinfosmall/flightinfosmall';
import FlightInfo from 'Vue/components/flightinfo/flightinfo';
import OpportunityListing from 'Vue/components/opportunityListing/opportunityListing';
import JobOpportunityListing from 'Vue/components/jobOpportunityListing/jobOpportunityListing';
import ParkingCalculator from 'Vue/components/parkingcalculator/parkingcalculator';
import AviationCalculator from 'Vue/components/aviationcharges/aviationCalculator';

//====--------- Step 2: register each Main Category with a createApp
const FlightInfoSmallCategory = createApp({});
const FlightInfoCategory = createApp({});
const OpportunityListingFilters = createApp({});
const JobOpportunityListingFilters = createApp({});
const AviationChargesCategory = createApp({});
const ParkingCalculatorCategory = createApp({});

//====--------- Step 3: Mount the main category to a unique identifier and register the components within that category.
if ($('#FlightPanel').length > 0) {
	FlightInfoSmallCategory.component('flightinfosmall', FlightInfoSmall);
	FlightInfoSmallCategory.mount('#FlightPanel');
}

if ($('#FlightInformation').length > 0) {
	FlightInfoCategory.component('flightinfo', FlightInfo);
	FlightInfoCategory.mount('#FlightInformation');
}

if ($('#js-opportunities').length > 0) {
	OpportunityListingFilters.component(
		'opportunitylisting',
		OpportunityListing,
	);
	OpportunityListingFilters.mount('#js-opportunities');
}

if ($('#js-job-opportunities').length > 0) {
	JobOpportunityListingFilters.component(
		'jobOpportunityListing',
		JobOpportunityListing,
	);
	JobOpportunityListingFilters.mount('#js-job-opportunities');
}

if ($('#AviationCharges').length > 0) {
	AviationChargesCategory.component('aviationcalculator', AviationCalculator);
	AviationChargesCategory.mount('#AviationCharges');
}

if ($('#ParkingCalculator').length > 0) {
	ParkingCalculatorCategory.component('parkingcalculator', ParkingCalculator);
	ParkingCalculatorCategory.mount('#ParkingCalculator');
}
